import { computed, watch } from 'vue';
import { VinceApp } from '../composables/usePermission';
import { useMenuStore } from '../stores/menuStore';
import { useUserStore } from '../stores/userStore';
import { APPS_PATH } from '../constants/common';
import { VL_UI_BASE_URL } from '../constants/backendUrls';
import { Menu } from 'vince-core/types/menu';

export default defineNuxtPlugin(() => {
    const store = useMenuStore();
    const userStore = useUserStore();
    const tenantInfo = computed(() => userStore.tenantInfo?.tenantName);
    const registerMenuItems = (tenant: string) => {
        const baseUrl = new URL(VL_UI_BASE_URL);
        baseUrl.hostname = `${tenant}.${baseUrl.hostname}`;
        baseUrl.pathname = APPS_PATH;
        store.addMenuItem('menus.subMenus.apps.clickAndCollect', `${baseUrl}/click-and-collect`, 1, Menu.APPS, undefined, undefined, {
            app: VinceApp.KANBAN
        });
        store.addMenuItem('menus.subMenus.apps.campaign', `${baseUrl}/campaign/dashboards`, 2, Menu.APPS, undefined, undefined, {
            app: VinceApp.CAMPAIGN
        });
        store.addMenuItem('menus.subMenus.apps.impexHelper', `${baseUrl}/impex-helper`, 3, Menu.APPS, undefined, undefined, {
            app: VinceApp.IMPEX_HELPER
        });
        store.addMenuItem('menus.subMenus.apps.mdbreadHelper', `${baseUrl}/mdbread-helper`, 4, Menu.APPS, undefined, undefined, {
            app: VinceApp.MDBREAD_HELPER
        });
        store.addMenuItem('menus.subMenus.apps.miTest', `${baseUrl}/mi-test`, 5, Menu.APPS, undefined, undefined, {
            app: VinceApp.MI_TEST
        });
        store.addMenuItem('menus.subMenus.apps.m3PrintoutConfig', `${baseUrl}/m3-printout-config`, 6, Menu.APPS, undefined, undefined, {
            app: VinceApp.M3_PRINTOUT_CONFIG
        });
        store.addMenuItem('menus.subMenus.apps.vincePricer', `${baseUrl}/pricer-helper`, 7, Menu.APPS, undefined, undefined, {
            app: VinceApp.VINCE_PRICER
        });
        store.addMenuItem('menus.subMenus.apps.cugexHelper', `${baseUrl}/cugex-helper`, 8, Menu.APPS, undefined, undefined, {
            app: VinceApp.CUGEX_HELPER
        });
        // store.addMenuItem('menus.subMenus.apps.lantmannenMaskin', `${baseUrl}/lantmannen-maskin`, 9, Menu.APPS);
        store.addMenuItem('menus.subMenus.apps.spykarChannelPlan', `${baseUrl}/spykar-channel-plan/list-items`, 10, Menu.APPS, undefined, undefined, {
            app: VinceApp.SPYKAR
        });
        store.addMenuItem('menus.subMenus.apps.eshopbox', `${baseUrl}/spykar-eshopbox/listorders`, 11, Menu.APPS, undefined, undefined, {
            app: VinceApp.ESHOPBOX
        });
        store.addMenuItem('menus.subMenus.apps.scannerPickPack', `${baseUrl}/scanner-pick-pack`, 12, Menu.APPS, undefined, undefined, {
            app: VinceApp.SCANNER_PICK_PACK
        });
        store.addMenuItem('menus.subMenus.apps.pickPack', `${baseUrl}/pick-pack`, 13, Menu.APPS, undefined, undefined, {
            app: VinceApp.PICK_PACK
        });
        store.addMenuItem('menus.subMenus.apps.contractManagement', `${baseUrl}/contract-management`, 14, Menu.APPS, undefined, undefined, {
            app: VinceApp.CONTRACT_MANAGEMENT
        });
    };

    watch(tenantInfo, (newTenant) => {
        if (newTenant) {
            registerMenuItems(newTenant);
        }
    }, { immediate: true });
});
